module.exports = __webpack_public_path__ + "static/img/noNotifications.70d7c1c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/noNotifications.png
// module id = 792
// module chunks = 4